// extracted by mini-css-extract-plugin
export var downArrow = "_b5-0";
export var label = "_b5-1";
export var treatmentCard = "_b5-3";
export var upArrow = "_b5-2";